import {
  MedicineBoxOutlined,
  RiseOutlined,
  SolutionOutlined,
  BarChartOutlined,
  InboxOutlined,
  WarningOutlined,
  AudioOutlined,
  OpenAIOutlined,
  FileSearchOutlined,
  MonitorOutlined,
  PhoneOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  SyncOutlined,
  CompassOutlined,
} from "@ant-design/icons";
import styles from "./styles.module.scss";
import { routes } from "../../router/mobile/routes";

export const tabs: ITabObject[] = [
  {
    key: routes.dashboard.path,
    title: "Inbox",
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
  {
    key: routes.Insights.path,
    title: "Insights",
    icon: <BarChartOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.clinical.path,
    title: "Trends",
    icon: <MedicineBoxOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.watchlist.path,
    title: "Watchlist",
    icon: <RiseOutlined className={styles.footerIcon} />,
  },
  // {
  //   key: routes.vitalSync.path,
  //   title: "Vitals",
  //   icon: <SyncOutlined className={styles.footerIcon} />,
  // },
  {
    key: routes.motionAndExits.path,
    title: "Bed Exits",
    icon: <WarningOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.myFacility.path,
    title: "Consents & devices",
    icon: <SolutionOutlined className={styles.footerIcon} />,
  },
];

export const tabsNP: ITabObject[] = [
  {
    key: routes.evaluationAndManagement.path, // for NPs make the default tab "Navigator"
    title: "Navigator",
    icon: <CompassOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.dashboard.path,
    title: "Inbox",
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
  {
    key: routes.Insights.path,
    title: "Insights",
    icon: <BarChartOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.clinical.path,
    title: "Trends",
    icon: <MedicineBoxOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.watchlist.path,
    title: "Watchlist",
    icon: <RiseOutlined className={styles.footerIcon} />,
  },

  {
    key: routes.myFacility.path,
    title: "Consents & devices",
    icon: <SolutionOutlined className={styles.footerIcon} />,
  },
];

export const tabsWeb: ITabObject[] = [
  {
    key: routes.dashboard.path,
    title: "Inbox",
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
  {
    key: routes.Insights.path,
    title: "Insights",
    icon: <BarChartOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.clinical.path,
    title: "Clinical",
    icon: <MedicineBoxOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.watchlist.path,
    title: "Watchlist",
    icon: <RiseOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.myFacility.path,
    title: "Consents & devices",
    icon: <SolutionOutlined className={styles.footerIcon} />,
  },
];

export const tabsWebNP: ITabObject[] = [
  {
    key: routes.evaluationAndManagement.path,
    title: "Navigator",
    icon: <CompassOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.dashboard.path,
    title: "Inbox",
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
  {
    key: routes.Insights.path,
    title: "Insights",
    icon: <BarChartOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.clinical.path,
    title: "Clinical",
    icon: <MedicineBoxOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.watchlist.path,
    title: "Watchlist",
    icon: <RiseOutlined className={styles.footerIcon} />,
  },

  {
    key: routes.myFacility.path,
    title: "Consents & devices",
    icon: <SolutionOutlined className={styles.footerIcon} />,
  },
];

export const premiumTabs: ITabObject[] = [
  {
    key: routes.motionAndExits.path,
    title: "Motion & exits",
    icon: <WarningOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.vitalSync.path,
    title: "Vitals",
    icon: <SyncOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.intercom.path,
    title: "Intercom",
    icon: <AudioOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.iq.path,
    title: "IQ",
    icon: <OpenAIOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.intake.path,
    title: "Intake",
    icon: <FileSearchOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.mds.path,
    title: "MDS",
    icon: <MonitorOutlined className={styles.footerIcon} />,
  },
  // {
  //   key: routes.rtBilling.path,
  //   title: "RT",
  //   icon: <DollarOutlined className={styles.footerIcon} />,
  // },
  {
    key: routes.voice.path,
    title: "Voice",
    icon: <PhoneOutlined className={styles.footerIcon} />,
  },
];

export const settingsTabs: ISupportTabObject[] = [
  {
    key: routes.settings.path,
    title: "Settings",
    icon: <SettingOutlined className={styles.footerIcon} />,
  },
  {
    key: "help-docs",
    title: "Help",
    icon: <QuestionCircleOutlined className={styles.footerIcon} />,
  },
];
